export default {"src":"/_next/static/media/saudi-arabia.c74f7e4e.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};